import homeRoute from './homeRoute'
import ReferralsRoute from './referralsRoute'
// import ResumeRoute from './resumeRoute'

const basePath = '/recruiting/personal'

export default {
  name: 'personalLayout',
  path: `${basePath}`,
  component: () => import('./index.vue'),
  redirect: homeRoute.path,
  meta: {
    personalLayout: {
      blankPage: false
    }
  },
  children: [
    homeRoute,
    ReferralsRoute
    // ResumeRoute
  ]
}
